export enum CultivationProtectionType {
  OnGround = 'OnGround',
  UnderProtection = 'UnderProtection',
  PartlyUnderProtection = 'PartlyUnderProtection',
  Greenhouse = 'Greenhouse'
}
